import React, { useRef } from 'react'
import { Container, SvgContainer, Indicator, Svg } from './style'

interface ICircleChartProps {
  radius: number
  strokeWidth: number
  valueArray: any[]
  children?: JSX.Element[] | JSX.Element | string
}

const CircleChart = (props: ICircleChartProps) => {
  const { radius = 120, strokeWidth = 10, valueArray = [], children } = props
  const circleRef = useRef(null)
  const halfCircle = radius + strokeWidth
  const circleCircunference = 2 * Math.PI * radius

  const sorted = valueArray.sort((a, b) => {
    return b.rate - a.rate
  })

  return (
    <Container>
      <SvgContainer>
        <Svg
          radius={radius}
          width={radius * 2}
          height={radius * 2}
          viewBox={`0 0 ${halfCircle * 2} ${halfCircle * 2}`}
        >
          <g r="-180" origin={`${halfCircle}, ${halfCircle}`}>
            {/* CIRCULO CINZA BASE */}
            <circle
              cx="50%"
              cy="50%"
              stroke={'#EEEEEE'}
              strokeWidth={strokeWidth}
              r={radius}
              fill={'transparent'}
            />

            {/* CIRCULOS COLORIDOS */}
            {sorted.map((item) => {
              return (
                <circle
                  className="animation-circle"
                  ref={circleRef}
                  key={`circle_${item.color}`}
                  cx="50%"
                  cy="50%"
                  stroke={'#DF7A58'}
                  strokeWidth={strokeWidth}
                  r={radius}
                  fill="transparent"
                  strokeDasharray={circleCircunference}
                  strokeDashoffset={circleCircunference * (1 - item.rate)}
                  strokeLinecap="round"
                />
              )
            })}
          </g>
        </Svg>
        <Indicator>{children}</Indicator>
      </SvgContainer>
    </Container>
  )
}

export default CircleChart
